
import currentYearMixin from "@/mixins/currentYearMixin"
import schoolSearchRouting from "@/models/schoolSearchRouting"
import { mapGetters } from "vuex"
import schoolPlaceholderDescription from "@/mixins/schoolPlaceholderDescription"
import eventService from "@/services/event.service"
import EventListNonRetarded from "@/components/event/EventListNonRetarded"
import InfoMaterials from "@/components/region/InfoMaterials"
import Hashtag from "@/components/base/Hashtag"
import CookieInformation from "@/components/layout/CookieInformation"

export default {
    meta: {
        searchPage: "true",
        toolbar: {
            hidden: true,
        },
        footer: {
            small: true,
            dark: true,
        },
    },
    name: "SchoolAlles",
    components: {
        CookieInformation,
        Hashtag,
        InfoMaterials,
        EventListNonRetarded,
        ApprenticeshipSearchResultList: () =>
            import("@/components/search/SearchResultList"),
        TraineeshipSearchResultList: () =>
            import("@/components/search/SearchResultList"),
    },
    layout(context) {
        if (context.route.query.embed) {
            return "fullscreen"
        }
        return context.$auth.user && context.$auth.user.school
            ? "modern"
            : "default"
    },
    mixins: [currentYearMixin, schoolPlaceholderDescription],
    async asyncData({ store, route, error }) {
        let categories = schoolSearchRouting.getRouting(route)

        const school = await store
            .dispatch("school/setCurrentDisplayedProfile", route.params.slug)
            .catch(() => {
                error({
                    statusCode: 404,
                    message: "Schule wurde nicht gefunden.",
                })
            })
        await store.dispatch("search/init", {
            categories: categories,
            selectedCategory: "Alles",
            locationSlug: route.params.slug,
            query: route.query,
            channel: school?.channel.slug,
            type: "school",
        })
        const { upcoming } = await eventService.getEvents(school?.channel.slug)
        return {
            school,
            events: upcoming,
        }
    },
    data: function () {
        return {
            school: {},
            events: [],
            materials: [],
            anyResults: true,
            selectedCategory: null,
            numberOfMaterials: 0,
            menuItems: [
                { color: "#ff27b0", text: "Ausbildung", key: "Ausbildung" },
                { color: "#ab12e1", text: "Praktikum", key: "Praktikum" },
                { color: "#0b79e8", text: "Events", key: "Events" },
                { color: "#06e288", text: "Materialien", key: "Materials" },
            ],
        }
    },
    mounted() {
        if (
            window.innerWidth < 1600 ||
            (this.$auth.loggedIn && window.innerWidth < 1900)
        ) {
            this.selectedCategory = "Ausbildung"
        }
    },
    watchQuery: true,
    methods: {
        selectCategory(category) {
            if (this.selectedCategory === category) {
                this.selectedCategory = null
            } else {
                this.selectedCategory = category
            }
        },
        onMaterialsChanged(number) {
            this.numberOfMaterials = number
        },
    },
    computed: {
        ...mapGetters("cookie", ["showCookieConsent"]),
        ...mapGetters("search", ["route", "searchID", "search"]),
        includeCookieHint() {
            return this.$route?.query?.embed
        },
        isHeaderVisible() {
            return this.$route?.query?.header !== "false"
        },
        channelSlug() {
            return this.school?.channel?.slug
        },
        schoolName() {
            return this.school.name
        },
        schoolImage() {
            return this.school.main_image
        },
        schoolType() {
            return this.school.type
        },
        numberOfApprenticeships() {
            return this.search(this.searchID("Ausbildung"))?.total
        },
        numberOfTraineeships() {
            return this.search(this.searchID("Praktikum"))?.total
        },
        metaTitle() {
            return `Berufsorientierung ${this.getSchoolTypePrefix(
                this.schoolType
            )} ${this.schoolName}`
        },
        metaDescription() {
            return `Arbeiten nach dem Schulabschluss ${this.getSchoolTypePrefix(
                this.schoolType,
                true
            )} ${
                this.schoolName
            }. Ausbildungs- und Praktikumsangebote von Partnerbetrieben in und um ${
                this.schoolCity
            }`
        },
    },
    head() {
        return {
            title: this.metaTitle,
            link: [
                {
                    rel: "canonical",
                    href: this.$config.baseURL + this.$route?.path,
                },
            ],
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.metaDescription,
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    title: `${this.metaTitle} | Oabat`,
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content: this.metaDescription,
                },
                {
                    hid: "og:image",
                    name: "og:image",
                    content: this.$getOGImage({
                        image: this.schoolImage,
                    }).src,
                },
                {
                    hid: "og:image:type",
                    name: "og:image:type",
                    content: this.$getOGImage({
                        image: this.schoolImage,
                    }).type,
                },
                {
                    hid: "og:image:alt",
                    name: "og:image:alt",
                    content: "Logo",
                },
            ],
        }
    },
}
